import React, { useMemo } from "react";

import "./index.scss";
import { safeGet } from "src/shared/utils";
import DetailsModel from "src/shared/models/DetailsModel";
import Shimmer from "src/shared/components/CustomisedShimmer";
import { devLogging } from "src/utils/logger";

type DetailsProps = {
  data: Array<{ label: string; valueField: string }>;
  charts: DetailsModel;
  loading: boolean;
};

const DetailsScroller = ({ charts, data, loading }: DetailsProps) => {
  // Configuration for Shimmer placeholders
  const barsConfig = useMemo(
    () => [
      {
        height: "1.2rem",
        width: "100%",
        repeatBar: 1,
        skimEffectColor: "#e6ecf5",
        elementSize: "LONG",
        backgroundColor: "#d1d0cf",
      },
    ],
    []
  );

  return (
    <div className="top-nav-details-imcom">
      {data?.length > 0 ? (
        data.map((item) => {
          devLogging("Rendering item:", charts);
          return (
            <div className="details-item-imcom" key={item.label}>
              {/* Loading Shimmer */}
              {loading && <Shimmer barsConfig={barsConfig} className="Shimmer-imcom" />}
              {/* Item Label */}
              {!loading && <div className="details-item-label-imcom">{item.label}</div>}
              {/* Chart or Fallback */}
              {!loading ? (
                <div className="details-item-value-imcom">{safeGet(charts, item.valueField, "N/A")}</div>
              ) : (
                <div className="details-404-imcom">{/*shimmer is already there*/}</div>
              )}
            </div>
          );
        })
      ) : (
        <div className="details-empty-imcom">No data available.</div>
      )}
    </div>
  );
};

export default DetailsScroller;
